(function () {
  'use strict';

  var MAIN_PRODUCT_ID = 7827443449899;
  var BAND_VARIANT_IDS = new Set([43112854159403, 43112854192171, 43112854224939, 43112854257707]);
  var EBOOK_PRODUCT_ID = 7831004872747;
  var EBOOK_VARIANT_ID = 43125251211307;
  var CART_MUTATION_RE = /\/cart\/(add(\.js)?|change(\.js)?|update(\.js)?)(\?|$)/;

  var isSyncing = false;
  var pendingSync = false;
  var scheduledSyncs = [];

  function getCart() {
    return fetch('/cart.js', { method: 'GET', headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function getLineProperty(item, key) {
    if (!item || !item.properties) return undefined;
    return item.properties[key];
  }

  function isMysteryGiftLine(item) {
    return item && Number(item.variant_id) === EBOOK_VARIANT_ID && String(getLineProperty(item, '_th_mystery_gift')) === 'true';
  }

  function isRegularEbookLine(item) {
    return item && Number(item.variant_id) === EBOOK_VARIANT_ID && !isMysteryGiftLine(item);
  }

  function getMainProductQty(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      return item && item.product_id === MAIN_PRODUCT_ID ? sum + Number(item.quantity || 0) : sum;
    }, 0);
  }

  function getOption3Qty(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      return item && item.product_id === MAIN_PRODUCT_ID && String(getLineProperty(item, '_th_bundle_option')) === '3'
        ? sum + Number(item.quantity || 0)
        : sum;
    }, 0);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      return response.json();
    });
  }

  function addGiftLine(properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: EBOOK_VARIANT_ID, quantity: 1, properties: properties || {} })
    }).then(function (response) {
      return response.json();
    });
  }

  function syncGiftLine(lines, shouldExist, properties) {
    var chain = Promise.resolve();
    var primary = lines && lines.length ? lines[0] : null;

    if (shouldExist) {
      if (!primary) {
        chain = chain.then(function () { return addGiftLine(properties); });
      } else if (Number(primary.quantity || 0) !== 1) {
        chain = chain.then(function () { return changeLine(primary.key, 1); });
      }
      (lines || []).slice(1).forEach(function (line) {
        chain = chain.then(function () { return changeLine(line.key, 0); });
      });
    } else {
      (lines || []).forEach(function (line) {
        chain = chain.then(function () { return changeLine(line.key, 0); });
      });
    }

    return chain;
  }

  function requestHasBand(body) {
    var ids = [];

    try {
      if (!body) return false;

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (value, key) {
          if (key === 'id' || /\[id\]$/.test(key)) ids.push(Number(value));
        });
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        body.forEach(function (value, key) {
          if (key === 'id' || /\[id\]$/.test(key)) ids.push(Number(value));
        });
      } else if (typeof body === 'string') {
        var params = new URLSearchParams(body);
        params.forEach(function (value, key) {
          if (key === 'id' || /\[id\]$/.test(key)) ids.push(Number(value));
        });
      } else if (typeof body === 'object') {
        if (Array.isArray(body.items)) {
          body.items.forEach(function (item) {
            ids.push(Number(item && item.id));
          });
        } else if (body.id) {
          ids.push(Number(body.id));
        }
      }
    } catch (_) {}

    return ids.some(function (id) {
      return BAND_VARIANT_IDS.has(id);
    });
  }

  function replaceSection(sectionId, html, selector) {
    var host = document.getElementById(sectionId);
    if (!host || !html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = selector ? doc.querySelector(selector) : doc.getElementById(sectionId) || doc.querySelector('.shopify-section');
    var target = selector ? host.querySelector(selector) || host : host;

    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  function refreshCartUi() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id) sections.push(mainCartItems.dataset.id);
    if (mainCartFooter && mainCartFooter.dataset.id) sections.push(mainCartFooter.dataset.id);

    return fetch('/?sections=' + encodeURIComponent(sections.join(',')), {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (renderedSections) {
        replaceSection('cart-drawer', renderedSections['cart-drawer'], '#CartDrawer');
        replaceSection('cart-icon-bubble', renderedSections['cart-icon-bubble'], '.shopify-section');

        if (mainCartItems && renderedSections[mainCartItems.dataset.id]) {
          replaceSection('main-cart-items', renderedSections[mainCartItems.dataset.id], '.js-contents');
        }

        if (mainCartFooter && renderedSections[mainCartFooter.dataset.id]) {
          replaceSection('main-cart-footer', renderedSections[mainCartFooter.dataset.id], '.js-contents');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tummyhush-gift-sync' });
        }
      })
      .catch(function (error) {
        console.log('TummyHush: cart UI refresh error', error);
      });
  }

  function runGiftSync() {
    if (isSyncing) {
      pendingSync = true;
      return Promise.resolve();
    }

    isSyncing = true;
    pendingSync = false;

    return getCart()
      .then(function (cart) {
        var mainQty = getMainProductQty(cart);
        var option3Qty = getOption3Qty(cart);
        var regularEbookLines = (cart.items || []).filter(isRegularEbookLine);
        var mysteryGiftLines = (cart.items || []).filter(isMysteryGiftLine);
        var shouldHaveEbook = mainQty > 0;
        var shouldHaveMysteryGift = option3Qty > 0;

        return syncGiftLine(regularEbookLines, shouldHaveEbook, { _th_ebook_gift: 'true' })
          .then(function () {
            return syncGiftLine(mysteryGiftLines, shouldHaveMysteryGift, { _th_mystery_gift: 'true' });
          })
          .then(function () {
            return refreshCartUi();
          });
      })
      .catch(function (error) {
        console.log('TummyHush: gift sync error', error);
      })
      .finally(function () {
        isSyncing = false;
        if (pendingSync) {
          pendingSync = false;
          runGiftSync();
        }
      });
  }

  function queueSync(delay) {
    var timeoutId = window.setTimeout(function () {
      scheduledSyncs = scheduledSyncs.filter(function (id) {
        return id !== timeoutId;
      });
      runGiftSync();
    }, typeof delay === 'number' ? delay : 250);

    scheduledSyncs.push(timeoutId);
    return timeoutId;
  }

  function queueMutationSync(options) {
    var delay = options && typeof options.delay === 'number' ? options.delay : 150;
    var immediate = !!(options && options.immediate);

    if (immediate) queueSync(0);
    queueSync(delay);
    queueSync(delay + 500);
  }

  function attachCheckoutInterceptors() {
    return;
  }

  function interceptDynamicCheckoutButtons() {
    return;
  }

  function installPubSubHooks() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }

    if (installPubSubHooks.installed) return true;
    installPubSubHooks.installed = true;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'tummyhush-gift-sync') return;
      queueMutationSync({ immediate: true, delay: 100 });
    });

    return true;
  }

  function installFetchInterceptor() {
    if (installFetchInterceptor.installed) return;
    installFetchInterceptor.installed = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var request = input;
      var url = typeof request === 'string' ? request : (request && request.url) || '';
      var method = String((init && init.method) || (request && request.method) || 'GET').toUpperCase();
      var body = init && init.body;
      var addsBand = CART_MUTATION_RE.test(url) && /\/cart\/add(\.js)?(\?|$)/.test(url) && requestHasBand(body);
      var result = originalFetch.apply(this, arguments);

      if (method === 'POST' && CART_MUTATION_RE.test(url)) {
        result
          .then(function () {
            queueMutationSync({ immediate: addsBand, delay: addsBand ? 50 : 150 });
          })
          .catch(function () {});
      }

      return result;
    };
  }

  function installXhrInterceptor() {
    if (installXhrInterceptor.installed) return;
    installXhrInterceptor.installed = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__thCartMethod = method;
      this.__thCartUrl = url || '';
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var method = String(this.__thCartMethod || 'GET').toUpperCase();
      var url = this.__thCartUrl || '';
      var addsBand = /\/cart\/add(\.js)?(\?|$)/.test(url) && requestHasBand(body);

      if (method === 'POST' && CART_MUTATION_RE.test(url)) {
        this.addEventListener('loadend', function () {
          queueMutationSync({ immediate: addsBand, delay: addsBand ? 50 : 150 });
        }, { once: true });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function installDomObserver() {
    return;
  }

  window.TummyHushEbookSync = window.TummyHushEbookSync || {};
  window.TummyHushEbookSync.sync = runGiftSync;
  window.TummyHushEbookSync.queue = queueMutationSync;

  function init() {
    installFetchInterceptor();
    installXhrInterceptor();
    installPubSubHooks();
    queueSync(150);
  }

  document.addEventListener('cart-drawer:open', function () {
    queueSync(100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
